import React from 'react';

import OperatorHit from 'components/OperatorHit';

import { times } from 'lodash';

import {
  OnSelectResultFn,
  OperatorTruckIndexRecord,
  SearchIndexResult,
} from 'lib/search';

const DEFAULT_LOADING_ELEMENTS_COUNT = 10;

interface SearchResultsListProps<T extends SearchIndexResult> {
  searchResults: T[];
  renderSearchResult?: any;
  renderLoadingResult?: any;
  isLoading?: boolean;
  isLoadingNextPage?: boolean;
  getOnClickHandler(searchResult: T, index: number): OnSelectResultFn<T>;
}

export default function SearchResultsList<T extends SearchIndexResult>(
  props: SearchResultsListProps<T>
) {
  return props.isLoading && !!props.renderLoadingResult ? (
    <>
      {
        // While results are loading render a list of dummy elements
        // using either the previous search result count or a default qty
        times(
          props.searchResults.length || DEFAULT_LOADING_ELEMENTS_COUNT,
          (i: number) => (
            <div key={i}>{props.renderLoadingResult()}</div>
          )
        )
      }
    </>
  ) : (
    <>
      {props.searchResults.map((searchResult, index) =>
        !!props.renderSearchResult ? (
          <div key={searchResult.objectID}>
            {props.renderSearchResult({
              key: searchResult.objectID,
              hit: searchResult,
              onClick: props.getOnClickHandler(searchResult, index),
            })}
          </div>
        ) : (
          <OperatorHit
            key={searchResult.objectID}
            hit={searchResult as unknown as OperatorTruckIndexRecord}
            onClick={
              props.getOnClickHandler(
                searchResult,
                index
              ) as unknown as OnSelectResultFn<OperatorTruckIndexRecord>
            }
          />
        )
      )}
      {props.isLoadingNextPage &&
        !!props.renderLoadingResult &&
        props.renderLoadingResult()}
    </>
  );
}
